package one.healthium.db

import kotlin.Long
import kotlin.String

public data class DailyTaskEntity(
  public val id: String,
  public val date: String,
  public val name: String,
  public val type: String,
  public val color: Long,
  public val payload: String?,
  public val completionCount: Long,
)
